(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref85b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref85b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2okK5", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $1bdde9abb9c4bc7f$export$6503ec6e8aabbaf; }, function (v) { return $1bdde9abb9c4bc7f$export$6503ec6e8aabbaf = v; });
var $1bdde9abb9c4bc7f$export$6503ec6e8aabbaf;
var $1bdde9abb9c4bc7f$export$f7ad0328861e2f03;
"use strict";
var $1bdde9abb9c4bc7f$var$mapping = new Map();
function $1bdde9abb9c4bc7f$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$1bdde9abb9c4bc7f$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $1bdde9abb9c4bc7f$var$resolve(id) {
    var resolved = $1bdde9abb9c4bc7f$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$1bdde9abb9c4bc7f$export$6503ec6e8aabbaf = $1bdde9abb9c4bc7f$var$register;
$1bdde9abb9c4bc7f$export$f7ad0328861e2f03 = $1bdde9abb9c4bc7f$var$resolve;

});

parcelRegister("1BDrg", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $12b7d6d85ca5dcbb$export$bdfd709ae4826697; }, function (v) { return $12b7d6d85ca5dcbb$export$bdfd709ae4826697 = v; });
var $12b7d6d85ca5dcbb$export$bdfd709ae4826697;
var $12b7d6d85ca5dcbb$export$c9e73fbda7da57b6;
var $12b7d6d85ca5dcbb$export$5a759dc7a1cfb72a;
"use strict";
var $12b7d6d85ca5dcbb$var$bundleURL = {};
function $12b7d6d85ca5dcbb$var$getBundleURLCached(id) {
    var value = $12b7d6d85ca5dcbb$var$bundleURL[id];
    if (!value) {
        value = $12b7d6d85ca5dcbb$var$getBundleURL();
        $12b7d6d85ca5dcbb$var$bundleURL[id] = value;
    }
    return value;
}
function $12b7d6d85ca5dcbb$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $12b7d6d85ca5dcbb$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $12b7d6d85ca5dcbb$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $12b7d6d85ca5dcbb$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$12b7d6d85ca5dcbb$export$bdfd709ae4826697 = $12b7d6d85ca5dcbb$var$getBundleURLCached;
$12b7d6d85ca5dcbb$export$c9e73fbda7da57b6 = $12b7d6d85ca5dcbb$var$getBaseURL;
$12b7d6d85ca5dcbb$export$5a759dc7a1cfb72a = $12b7d6d85ca5dcbb$var$getOrigin;

});

parcelRegister("icA1S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4054babfeb9ed2a$export$2e2bcd8739ae039; });

var $cHKqy = parcelRequire("cHKqy");

var $4WWN5 = parcelRequire("4WWN5");

var $kJJDx = parcelRequire("kJJDx");

var $c9Mx7 = parcelRequire("c9Mx7");

var $2qlz5 = parcelRequire("2qlz5");
var $d4054babfeb9ed2a$var$previewView = /*#__PURE__*/ function(appView) {
    "use strict";
    (0, $kJJDx._)(previewView, appView);
    var _super = (0, $c9Mx7._)(previewView);
    function previewView() {
        (0, $cHKqy._)(this, previewView);
        return _super.apply(this, arguments);
    }
    (0, $4WWN5._)(previewView, [
        {
            key: "notesMarkup",
            value: function notesMarkup(data, options) {
                return '\n          <div class="note-item all-notes '.concat(data.tag, " ").concat(options.favorite, '" data-id="').concat(data.id, '" data-favorited="').concat(data.favorited, '">\n            <div class="note-inner-content">\n              <div class="note-content">\n                <p class="note-title" data-noteTitle="').concat(data.title, '">\n                  ').concat(options.limitTitle, '\n                </p>\n                <p class="meta-time">\n                 ').concat(options.edited, " ").concat(options.newDate, '\n                </p>\n                <div class="note-description-content">\n                  <p class="note-description" data-noteDescription="').concat(data.description, '">\n                    ').concat(options.limitDescription, '\n                  </p>\n                </div>\n              </div>\n              <div class="note-action">\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star fav-note">\n                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>\n                </svg>\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2 delete-note">\n                  <polyline points="3 6 5 6 21 6"></polyline>\n                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>\n                  <line x1="10" y1="11" x2="10" y2="17"></line>\n                  <line x1="14" y1="11" x2="14" y2="17"></line>\n                </svg>\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2 edit-note"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>\n              </div>\n              <div class="note-footer">\n                <div class="tags-selector btn-group">\n                  <a class="nav-link dropdown-toggle d-icon label-group" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="true">\n                    <span>\n                      <div class="tags">\n                        <div class="g-dot-personal"></div>\n                        <div class="g-dot-work"></div>\n                        <div class="g-dot-social"></div>\n                        <div class="g-dot-important"></div>\n                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical">\n                          <circle cx="12" cy="12" r="1"></circle>\n                          <circle cx="12" cy="5" r="1"></circle>\n                          <circle cx="12" cy="19" r="1"></circle>\n                        </svg>\n                      </div>\n                    </span>\n                  </a>\n                  <div class="dropdown-menu dropdown-menu-right d-icon-menu">\n                    <a class="note-personal label-group-item label-personal dropdown-item position-relative g-dot-personal" href="javascript:void(0);"> Personal</a>\n                    <a class="note-work label-group-item label-work dropdown-item position-relative g-dot-work" href="javascript:void(0);"> Work</a>\n                    <a class="note-social label-group-item label-social dropdown-item position-relative g-dot-social" href="javascript:void(0);"> Social</a>\n                    <a class="note-important label-group-item label-important dropdown-item position-relative g-dot-important" href="javascript:void(0);"> Important</a>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        ');
            }
        },
        {
            key: "todoMarkup",
            value: function todoMarkup(data, options) {
                return '\n      <div class="todo-item '.concat(data.trash ? "" : "all-list", " ").concat(options.important, " ").concat(options.completed, " ").concat(options.trash, '" data-id="').concat(data.id, '" data-completed="').concat(data.completed, '" data-trash="').concat(data.trash, '"\n      data-important="').concat(data.important, '" data-priority="').concat(data.priority, '">\n        <div class="todo-item-inner">\n          <div class="n-chk text-center">\n            <div class="form-check form-check-primary form-check-inline mt-1 me-0" data-bs-toggle="collapse" data-bs-target="">\n              <input class="form-check-input inbox-chkbox" type="checkbox" ').concat(data.completed ? "checked" : "", '>\n            </div>\n          </div>\n\n          <div class="todo-content">\n            <h5 class="todo-heading" data-todoheading="').concat(data.title, '">\n             ').concat(options.limitTitle, '\n            </h5>\n            <p class="todo-text" data-todohtml="').concat(data.description, '" data-todotext="').concat(data.description, '">\n              ').concat(data.description, '\n            </p>\n          </div>\n\n          <div class="meta-frame">\n            <p class="meta-time todo-time">').concat(options.isCompleted, " ").concat(options.edited, " ").concat(options.newDate, '</p>\n          </div>\n\n          <div class="priority-dropdown custom-dropdown-icon">\n            <div class="dropdown p-dropdown">\n              <a class="dropdown-toggle ').concat(data.priority, '" href="#" role="button" id="dropdownMenuLink-1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                  <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                  <line x1="12" y1="8" x2="12" y2="12"></line>\n                  <line x1="12" y1="16" x2="12" y2="16"></line>\n                </svg>\n              </a>\n\n              <div class="dropdown-menu left" aria-labelledby="dropdownMenuLink-1">\n                <a class="danger dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                    <line x1="12" y1="8" x2="12" y2="12"></line>\n                    <line x1="12" y1="16" x2="12" y2="16"></line>\n                  </svg>\n                  High</a>\n                <a class="warning dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                    <line x1="12" y1="8" x2="12" y2="12"></line>\n                    <line x1="12" y1="16" x2="12" y2="16"></line>\n                  </svg>\n                  Middle</a>\n                <a class="primary dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                    <line x1="12" y1="8" x2="12" y2="12"></line>\n                    <line x1="12" y1="16" x2="12" y2="16"></line>\n                  </svg>\n                  Low</a>\n              </div>\n            </div>\n          </div>\n\n          <div class="action-dropdown custom-dropdown-icon">\n            <div class="dropdown">\n              <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink-2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical">\n                  <circle cx="12" cy="12" r="1"></circle>\n                  <circle cx="12" cy="5" r="1"></circle>\n                  <circle cx="12" cy="19" r="1"></circle>\n                </svg>\n              </a>\n\n              <div class="dropdown-menu left" aria-labelledby="dropdownMenuLink-2">\n                <a class="edit dropdown-item" href="javascript:void(0);">Edit</a>\n                <a class="important dropdown-item" href="javascript:void(0);">').concat(data.important === 1 ? "Mark as Normal" : "Mark as Important", '</a>\n                <a class="dropdown-item delete" href="javascript:void(0);">Delete</a>\n                <a class="dropdown-item permanent-delete" href="javascript:void(0);">Permanent Delete</a>\n                <a class="dropdown-item revive" href="javascript:void(0);">Revive Task</a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    ');
            }
        },
        {
            key: "scrumBoardMarkup",
            value: function scrumBoardMarkup(data) {
                return '\n        <div data-draggable="true" data-list-id="'.concat(data.tasksection, '" data-card-id="').concat(data.id, '" data-order="').concat(data.order, '" class="card task-text-progress" style="">\n          <div class="card-body">\n            <div class="task-header">\n              <div>\n                <h4 class="" data-taskTitle="').concat(data.title, '">').concat(data.title, '</h4>\n              </div>\n              <div>\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2 s-task-edit">\n                  <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>\n                </svg>\n              </div>\n            </div>\n            <div class="task-body">\n              <div class="task-content">\n                <p class="" data-taskText="').concat(data.description, '">').concat(data.description, '</p>\n                <div class="').concat(data.progress ? "" : "progress-none-bar d-none", '">\n                    <div class="progress br-30">\n                      <div class="progress-bar bg-success" role="progressbar" data-progressstate="').concat(data.progress, '" style="width: ').concat(data.progress, '%" aria-valuenow="').concat(data.progress, '" aria-valuemin="0" aria-valuemax="100">\n                      </div>\n                    </div>\n                    <p class="progress-count">').concat(data.progress, '%</p>\n                </div>\n              </div>\n              <div class="task-bottom">\n                <div class="tb-section-1">\n                  <span data-taskDate="').concat(data.date, '">\n                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar">\n                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>\n                      <line x1="16" y1="2" x2="16" y2="6"></line>\n                      <line x1="8" y1="2" x2="8" y2="6"></line>\n                      <line x1="3" y1="10" x2="21" y2="10"></line>\n                    </svg>\n                    ').concat(data.date, '\n                  </span>\n                </div>\n                <div class="tb-section-2">\n                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2 s-task-delete">\n                    <polyline points="3 6 5 6 21 6"></polyline>\n                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>\n                    <line x1="10" y1="11" x2="10" y2="17"></line>\n                    <line x1="14" y1="11" x2="14" y2="17"></line>\n                  </svg>\n                </div>\n              </div>\n            </div>\n          </div>');
            }
        },
        {
            key: "scrumListMarkup",
            value: function scrumListMarkup(data) {
                return '\n    <div data-section="'.concat(data.id, '" data-order="').concat(data.order, '" class="task-list-container mb-4 " data-connect="sorting">\n      <div class="connect-sorting">\n        <div class="task-container-header">\n          <h6 class="s-heading" data-listTitle="').concat(data.title, '">\n            ').concat(data.title, '\n          </h6>\n          <div class="dropdown">\n            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink-4" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal">\n                <circle cx="12" cy="12" r="1"></circle>\n                <circle cx="19" cy="12" r="1"></circle>\n                <circle cx="5" cy="12" r="1"></circle>\n              </svg>\n            </a>\n            <div class="dropdown-menu dropdown-menu-right left" aria-labelledby="dropdownMenuLink-4">\n              <a class="dropdown-item list-edit" href="javascript:void(0);">Edit List</a>\n              <a class="dropdown-item list-delete" href="javascript:void(0);">Delete List</a>\n              <a class="dropdown-item list-clear-all" href="javascript:void(0);">Clear All Cards</a>\n            </div>\n          </div>\n        </div>\n        <div class="connect-sorting-content" data-sortable="true">\n        </div>\n        <div class="add-s-task">\n          <a class="addTask">\n            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle">\n              <circle cx="12" cy="12" r="10"></circle>\n              <line x1="12" y1="8" x2="12" y2="16"></line>\n              <line x1="8" y1="12" x2="16" y2="12"></line>\n            </svg>\n            Add Task\n          </a>\n        </div>\n      </div>\n    </div>\n  ');
            }
        },
        {
            key: "timeLineMarkup",
            value: function timeLineMarkup(data, timeFormat) {
                return '\n          <div class="item-timeline">\n            <p class="t-time">'.concat(timeFormat.timeDigits, '</p>\n            <div class="t-dot t-dot-').concat(data.tag, '"></div>\n            <div class="t-text">\n              <p>').concat(data.title, '</p>\n              <p class="t-meta-time">').concat(timeFormat.timeAgo, "</p>\n              ").concat(data.startdate ? '<p class="t-meta-time event-time"> '.concat(data.startdate, "</p>") : "", "\n            </div>\n          </div>\n    ");
            }
        }
    ]);
    return previewView;
}((0, $2qlz5.default));
var $d4054babfeb9ed2a$export$2e2bcd8739ae039 = new $d4054babfeb9ed2a$var$previewView();

});

var $9a9859cb70536c0e$exports = {};


(parcelRequire("2okK5")).register((parcelRequire("1BDrg")).getBundleURL("cXSkt"), JSON.parse('["cXSkt","index.f68424fb.js","bSvGf","emptypage.dadd159b.gif","4txRv","scrumboard.1a3e9999.js","4qOEF","scrumboard.48256f97.css"]'));


var $8yqAw = parcelRequire("8yqAw");

var $h9q22 = parcelRequire("h9q22");

var $cHKqy = parcelRequire("cHKqy");

var $4WWN5 = parcelRequire("4WWN5");

var $4RD37 = parcelRequire("4RD37");

var $kJJDx = parcelRequire("kJJDx");

var $c9Mx7 = parcelRequire("c9Mx7");

var $cDnFD = parcelRequire("cDnFD");

var $jemUx = parcelRequire("jemUx");
var $42dce1800fb819e9$exports = {};

$42dce1800fb819e9$exports = (parcelRequire("1BDrg")).getBundleURL("cXSkt") + "emptypage.dadd159b.gif";



var $icA1S = parcelRequire("icA1S");

var $2qlz5 = parcelRequire("2qlz5");

var $aNKSX = parcelRequire("aNKSX");
var $b2b85ecb3cfeb444$var$Timeline = /*#__PURE__*/ function(appView) {
    "use strict";
    (0, $kJJDx._)(Timeline, appView);
    var _super = (0, $c9Mx7._)(Timeline);
    function Timeline() {
        (0, $cHKqy._)(this, Timeline);
        var _this;
        _this = _super.call(this);
        (0, $4RD37._)((0, $8yqAw._)(_this), "_noteTimeline", document.querySelector("#noteTimeline").querySelector(".timeline-line"));
        (0, $4RD37._)((0, $8yqAw._)(_this), "_todoTimeline", document.querySelector("#todoTimeline").querySelector(".timeline-line"));
        (0, $4RD37._)((0, $8yqAw._)(_this), "_eventTimeline", document.querySelector("#eventTimeline").querySelector(".timeline-line"));
        (0, $4RD37._)((0, $8yqAw._)(_this), "_scrumTimeline", document.querySelector("#scrumTimeline").querySelector(".timeline-line"));
        (0, $4RD37._)((0, $8yqAw._)(_this), "_timelineAlert", document.querySelector(".alert-arrow-right"));
        (0, $4RD37._)((0, $8yqAw._)(_this), "_emptyPage", function(element) {
            var markup = '\n      <div class="empty-image">\n        <img\n          class="image-none"\n          src="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($42dce1800fb819e9$exports))), '"\n          alt=""\n        />\n      </div>\n  ');
            element.insertAdjacentHTML("beforeend", markup);
        });
        (0, $4RD37._)((0, $8yqAw._)(_this), "_generateTimelineMarkup", function(data, element) {
            var timeDigits = this.formatTime(data.timestamp);
            var timeAgo = this.relativeTime(data.timestamp);
            var timeFormat = {
                timeDigits: timeDigits,
                timeAgo: timeAgo
            };
            var markup = (0, $icA1S.default).timeLineMarkup(data, timeFormat);
            element.insertAdjacentHTML("beforeend", markup);
        });
        _this.initialize();
        return _this;
    }
    (0, $4WWN5._)(Timeline, [
        {
            key: "initialize",
            value: function initialize() {
                var _this = this;
                return (0, $h9q22._)(function() {
                    return (0, $cDnFD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._LoadTimeline()
                                ];
                            case 1:
                                _state.sent();
                                _this._loadTodo();
                                _this._loadEvents();
                                _this._loadScrum();
                                _this._loadNotes();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_displayEmptyText",
            value: function _displayEmptyText(messageEl, message) {
                this._timelineAlert.style.display = "block";
                messageEl.textContent = message;
            }
        },
        {
            key: "_hideEmptyText",
            value: function _hideEmptyText(messageEl, message) {
                this._timelineAlert.style.display = "none";
                messageEl.textContent = message;
            }
        },
        {
            key: "_loadTodo",
            value: function _loadTodo() {
                var self = this;
                $("#pills-todo-tab").on("click", function() {
                    var _ref = (0, $h9q22._)(function(e) {
                        var emptyText, filterFunction, data, sortedData, first10Items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, todo, newData, err;
                        return (0, $cDnFD.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    e.preventDefault();
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    emptyText = document.getElementById("todoTimeline").querySelector(".empty-text");
                                    filterFunction = function(item) {
                                        return item.completed === 0;
                                    };
                                    return [
                                        4,
                                        $jemUx.getAllItemsFromDatabase("todo", filterFunction)
                                    ];
                                case 2:
                                    data = _state.sent();
                                    sortedData = self.sortDataByTimestamp(data);
                                    first10Items = sortedData.slice(0, 10);
                                    if (first10Items.length === 0) {
                                        self._todoTimeline.innerHTML = "";
                                        self._displayEmptyText(emptyText, "Empty Lists");
                                        self._emptyPage(self._todoTimeline);
                                    } else {
                                        self._todoTimeline.innerHTML = "";
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(_iterator = first10Items[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                todo = _step.value;
                                                newData = {
                                                    title: todo.title,
                                                    tag: todo.priority,
                                                    timestamp: todo.timestamp
                                                };
                                                self._hideEmptyText(emptyText, "Get Things Done");
                                                self._generateTimelineMarkup(newData, self._todoTimeline);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    }
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    err = _state.sent();
                                    self.failedMessageInfo((0, $aNKSX.FAILEDMESSAGE));
                                    return [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "_loadNotes",
            value: function _loadNotes() {
                var self = this;
                $("#pills-notes-tab").on("click", function() {
                    var _ref = (0, $h9q22._)(function(e) {
                        return (0, $cDnFD.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    e.preventDefault();
                                    return [
                                        4,
                                        self._LoadTimeline()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "_formatNotesTag",
            value: function _formatNotesTag(note) {
                var tag;
                if (note === "note-personal") tag = "success";
                else if (note === "note-work") tag = "warning";
                else if (note === "note-social") tag = "info";
                else tag = "danger";
                return tag;
            }
        },
        {
            key: "_LoadTimeline",
            value: function _LoadTimeline() {
                var _this = this;
                return (0, $h9q22._)(function() {
                    var emptyText, data, sortedData, first10Items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, note, newData, err1;
                    return (0, $cDnFD.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                emptyText = document.getElementById("noteTimeline").querySelector(".empty-text");
                                return [
                                    4,
                                    $jemUx.getAllItemsFromDatabase("notes")
                                ];
                            case 1:
                                data = _state.sent();
                                sortedData = _this.sortDataByTimestamp(data);
                                first10Items = sortedData.slice(0, 10);
                                if (first10Items.length === 0) {
                                    _this._noteTimeline.innerHTML = "";
                                    _this._displayEmptyText(emptyText, "Empty Notes");
                                    _this._emptyPage(_this._noteTimeline);
                                } else {
                                    _this._noteTimeline.innerHTML = "";
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = first10Items[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            note = _step.value;
                                            newData = {
                                                title: note.title,
                                                tag: _this._formatNotesTag(note.tag),
                                                timestamp: note.timestamp
                                            };
                                            _this._hideEmptyText(emptyText, "Quick Notes");
                                            _this._generateTimelineMarkup(newData, _this._noteTimeline);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err1 = _state.sent();
                                _this.failedMessageInfo((0, $aNKSX.FAILEDMESSAGE));
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_formatEventsTag",
            value: function _formatEventsTag(event) {
                var tag;
                if (event === "Personal") tag = "success";
                else if (event === "Travel") tag = "warning";
                else if (event === "Work") tag = "primary";
                else tag = "danger";
                return tag;
            }
        },
        {
            key: "_loadEvents",
            value: function _loadEvents() {
                var self = this;
                $("#pills-event-tab").on("click", function() {
                    var _ref = (0, $h9q22._)(function(e) {
                        var emptyText, data, currentDate, proximityThreshold, filteredData, first10Items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, event, newData, err1;
                        return (0, $cDnFD.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    e.preventDefault();
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    emptyText = document.getElementById("eventTimeline").querySelector(".empty-text");
                                    return [
                                        4,
                                        $jemUx.getAllItemsFromDatabase("event")
                                    ];
                                case 2:
                                    data = _state.sent();
                                    currentDate = new Date();
                                    proximityThreshold = 432000000;
                                    filteredData = data.filter(function(item) {
                                        var eventStartDate = new Date(item.start);
                                        var timeDifference = eventStartDate.getTime() - currentDate.getTime();
                                        return timeDifference >= 0 && timeDifference <= proximityThreshold;
                                    });
                                    first10Items = filteredData.slice(0, 10);
                                    if (first10Items.length === 0) {
                                        self._eventTimeline.innerHTML = "";
                                        self._displayEmptyText(emptyText, "Empty Events");
                                        self._emptyPage(self._eventTimeline);
                                    } else {
                                        self._eventTimeline.innerHTML = "";
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(_iterator = first10Items[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                event = _step.value;
                                                newData = {
                                                    title: event.title,
                                                    tag: self._formatEventsTag(event.extendedProps.calendar),
                                                    timestamp: event.timestamp,
                                                    startdate: event.start.split("T")[0]
                                                };
                                                self._hideEmptyText(emptyText, "Upcoming Events");
                                                self._generateTimelineMarkup(newData, self._eventTimeline);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    }
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    err1 = _state.sent();
                                    self.failedMessageInfo((0, $aNKSX.FAILEDMESSAGE));
                                    return [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "_formatScrumTag",
            value: function _formatScrumTag(scrum) {
                var tag;
                if (scrum === "s-in-progress") tag = "success";
                else if (scrum === "s-new") tag = "primary";
                else tag = "warning";
                return tag;
            }
        },
        {
            key: "_loadScrum",
            value: function _loadScrum() {
                var self = this;
                $("#pills-scrum-tab").on("click", function() {
                    var _ref = (0, $h9q22._)(function(e) {
                        var emptyText, data, sortedData, first10Items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, scrum, newData, err1;
                        return (0, $cDnFD.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    e.preventDefault();
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    emptyText = document.getElementById("scrumTimeline").querySelector(".empty-text");
                                    return [
                                        4,
                                        $jemUx.getAllItemsFromDatabase("scrumboard")
                                    ];
                                case 2:
                                    data = _state.sent();
                                    sortedData = self.sortDataByTimestamp(data);
                                    first10Items = sortedData.slice(0, 10);
                                    if (first10Items.length === 0) {
                                        self._scrumTimeline.innerHTML = "";
                                        self._displayEmptyText(emptyText, "Empty Tasks");
                                        self._emptyPage(self._scrumTimeline);
                                    } else {
                                        self._scrumTimeline.innerHTML = "";
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(_iterator = first10Items[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                scrum = _step.value;
                                                newData = {
                                                    title: scrum.title,
                                                    tag: self._formatScrumTag(scrum.tasksection),
                                                    timestamp: scrum.timestamp
                                                };
                                                self._hideEmptyText(emptyText, "Organize Tasks");
                                                self._generateTimelineMarkup(newData, self._scrumTimeline);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    }
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    err1 = _state.sent();
                                    self.failedMessageInfo((0, $aNKSX.FAILEDMESSAGE));
                                    return [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        }
    ]);
    return Timeline;
}((0, $2qlz5.default));
new $b2b85ecb3cfeb444$var$Timeline();

})();
//# sourceMappingURL=index.f68424fb.js.map
